import type { SVGProps } from 'react';

const SvgAnnotationLaser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 11h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1m-6 4c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1m0-6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1m3.54 5.12a.996.996 0 1 0-1.41 1.41l2.83 2.83c.2.19.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-2.83-2.83zM8.46 9.88c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L7.71 6.3A.996.996 0 1 0 6.3 7.71l2.17 2.17zm0 4.24-2.17 2.17a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.17-2.17a.996.996 0 1 0-1.41-1.41zm6.27-3.85c.26 0 .51-.1.71-.29l1.77-1.77A.996.996 0 1 0 15.8 6.8l-1.77 1.77a.996.996 0 0 0 .71 1.7zm5.25-5.46c0-.07-.03-.13-.06-.19-.05-.12-.12-.24-.21-.33a.9.9 0 0 0-.33-.21.92.92 0 0 0-.76 0q-.18.075-.33.21c-.04.05-.09.1-.12.15q-.06.09-.09.18c-.03.06-.05.12-.06.19 0 .06-.02.13-.02.19 0 .26.11.52.29.71q.15.135.33.21c.12.06.25.08.38.08s.26-.02.38-.08q.195-.075.33-.21c.04-.05.09-.1.12-.16.04-.05.07-.11.09-.17q.045-.09.06-.18c.02-.07.02-.13.02-.2 0-.06 0-.13-.02-.19M12 10.5c-.44 0-.84.2-1.11.5H4c-.55 0-1 .45-1 1s.45 1 1 1h6.89c.27.3.67.5 1.11.5.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
  </svg>
);
export default SvgAnnotationLaser;
